import { title } from '@/@core/utils/filter'
import rewards from './rewards'

export default [
  ...rewards,
  // Kasir Shift Management Routes
  {
    path: '/kasir/shifts',
    name: 'kasir-shifts',
    component: () => import('@/views/apps/kasir/ShiftReport.vue'),
    meta: {
      title: 'Laporan Shift Kasir',
      pageTitle: 'Laporan Shift Kasir',
      breadcrumb: [
        {
          text: 'Laporan',
        },
        {
          text: 'Keuangan',
          to: { name: 'apps-laporan-keuangan' },
        },
        {
          text: 'Shift Kasir',
          active: true,
        },
      ],
      resource: 'laporan',
      action: 'view',
    },
  },
  {
    path: '/kasir/shifts/:id',
    name: 'kasir-shift-detail',
    component: () => import('@/views/apps/kasir/ShiftDetail.vue'),
    meta: {
      title: 'Detail Shift Kasir',
      key: 'fullPath',
      resource: 'laporan',
      action: 'view',
    },
  },
  // AI Badge Examples - Development/Testing Route
  {
    path: '/ai-badge-examples',
    name: 'ai-badge-examples',
    component: () => import('@/components/common/AiBadgeExamples.vue'),
    meta: {
      layout: 'content',
      title: 'AI Badge Examples',
      resource: 'Auth',
      action: 'read',
      alwaysAccessible: process.env.NODE_ENV === 'development' || process.env.VUE_APP_ENVIRONMENT === 'local'
    }
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
      alwaysAccessible: true
    }
  },
  {
    path: '/nps/:token',
    name: 'public-nps-form',
    component: () => import('@/views/public/PublicNpsForm.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
      alwaysAccessible: true,
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      alwaysAccessible: true
    }
  },
  {
    path: '/pages/authentication/login-v1',
    name: 'auth-login-v1',
    component: () => import('@/views/pages/authentication/Login-v1.vue'),
    meta: {
      layout: 'full'
    }
  },
  {
    path: '/pages/authentication/login-v2',
    name: 'auth-login-v2',
    component: () => import('@/views/pages/authentication/Login-v2.vue'),
    meta: {
      layout: 'full'
    }
  },
  {
    path: '/register',
    name: 'auth-register',
    component: () => import('@/views/pages/authentication/Register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      alwaysAccessible: true
    }
  },
  {
    path: '/pages/authentication/register-v1',
    name: 'auth-register-v1',
    component: () => import('@/views/pages/authentication/Register-v1.vue'),
    meta: {
      layout: 'full'
    }
  },
  {
    path: '/pages/authentication/register-v2',
    name: 'auth-register-v2',
    component: () => import('@/views/pages/authentication/Register-v2.vue'),
    meta: {
      layout: 'full'
    }
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
      alwaysAccessible: true
    }
  },
  {
    path: '/pages/authentication/forgot-password-v1',
    name: 'auth-forgot-password-v1',
    component: () =>
      import('@/views/pages/authentication/ForgotPassword-v1.vue'),
    meta: {
      layout: 'full'
    }
  },
  {
    path: '/pages/authentication/forgot-password-v2',
    name: 'auth-forgot-password-v2',
    component: () =>
      import('@/views/pages/authentication/ForgotPassword-v2.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth'
    }
  },
  {
    path: '/pages/authentication/reset-password-v1',
    name: 'auth-reset-password-v1',
    component: () =>
      import('@/views/pages/authentication/ResetPassword-v1.vue'),
    meta: {
      layout: 'full'
    }
  },
  {
    path: '/pages/authentication/reset-password-v2',
    name: 'auth-reset-password-v2',
    component: () =>
      import('@/views/pages/authentication/ResetPassword-v2.vue'),
    meta: {
      layout: 'full'
    }
  },
  {
    path: '/apps/antrean',
    name: 'apps-antrean',
    component: () => import('@/views/apps/antrean/Index.vue'),
    meta: {
      // contentRenderer: 'sidebar-left',
      contentClass: 'antrean-application',
      title: 'Antrean',
      key: 'fullPath',
      resource: 'antrean',
      feature: 'rawat_jalan'
    }
  },
  {
    path: '/apps/kunjungan',
    name: 'apps-kunjungan',
    component: () => import('@/views/apps/kunjungan/Index.vue'),
    meta: {
      // contentRenderer: 'sidebar-left',
      contentClass: 'kunjungan-application',
      title: 'Kunjungan',
      key: 'fullPath',
      resource: 'kunjungan',
      feature: 'rawat_jalan'
    }
  },
  {
    path: '/apps/pasien',
    name: 'apps-pasien',
    component: () => import('@/views/apps/pasien/Pasien.vue'),
    meta: {
      title: 'Daftar Pasien',
      key: 'fullPath',
      resource: 'tabel pasien',
      feature: 'rawat_jalan'
    }
  },
  {
    path: '/apps/pasien/:norm',
    name: 'apps-pasien-detail',
    component: () => import('@/views/apps/pasien/DetailPasien.vue'),
    meta: {
      title(route) {
        return `Pasien ${route.params.norm}`
      },
      key: 'fullPath',
      resource: 'detail pasien',
      feature: 'rawat_jalan',
      keepAlive: false
    }
  },
  {
    path: '/apps/penjualan',
    name: 'apps-penjualan',
    component: () => import('@/views/apps/penjualan/Penjualan.vue'),
    meta: {
      title: 'Penjualan',
      key: 'fullPath',
      resource: 'pos',
      feature: 'pos'
    }
  },
  {
    path: '/apps/purchase-order',
    name: 'apps-purchase-order',
    component: () => import('@/views/apps/purchase-order/PurchaseOrder.vue'),
    meta: {
      title: 'Pembelian',
      key: 'fullPath',
      resource: 'stock',
      feature: 'inventory'
    }
  },
  {
    path: '/apps/penerimaan',
    name: 'apps-penerimaan',
    component: () => import('@/views/apps/penerimaan/Penerimaan.vue'),
    meta: {
      title: 'Penerimaan',
      key: 'fullPath',
      resource: 'stock',
      feature: 'inventory'
    }
  },
  {
    path: '/apps/opname',
    name: 'apps-opname',
    component: () => import('@/views/apps/opname/Index.vue'),
    meta: {
      title: 'Opname',
      key: 'fullPath',
      resource: 'stock',
      feature: 'inventory'
    }
  },
  {
    path: '/apps/penyesuaian-stok',
    name: 'apps-penyesuaian-stok',
    component: () => import('@/views/apps/penyesuaian-stok/Index.vue'),
    meta: {
      title: 'Penyesuaian Stok',
      key: 'fullPath',
      resource: 'penyesuaian_stok',
      feature: 'inventory'
    }
  },
  {
    path: '/apps/tempo',
    name: 'apps-tempo',
    component: () => import('@/views/apps/hutang/Index.vue'),
    meta: {
      title: 'Pelunasan Tempo',
      key: 'fullPath',
      resource: 'pelunasan hutang',
      feature: 'inventory'
    }
  },
  {
    path: '/apps/buku-kas',
    name: 'apps-buku-kas',
    component: () => import('@/views/apps/pengeluaran/Index.vue'),
    meta: {
      title: 'Buku Kas',
      key: 'fullPath',
      resource: 'buku kas',
      feature: 'inventory'
    }
  },
  {
    path: '/apps/laporan',
    name: 'apps-laporan',
    component: () => import('@/views/apps/laporan/tabs/Rangkuman.vue'),
    meta: {
      title: 'Laporan',
      key: 'fullPath',
      resource: 'laporan'
    }
  },
  {
    path: '/apps/laporan/pengunjung',
    name: 'apps-laporan-pengunjung',
    component: () => import('@/views/apps/laporan/tabs/Pengunjung.vue'),
    meta: {
      title: 'Laporan',
      key: 'fullPath',
      resource: 'laporan'
    }
  },
  {
    path: '/apps/laporan/inventori',
    name: 'apps-laporan-inventori',
    component: () => import('@/views/apps/laporan/tabs/Inventory.vue'),
    meta: {
      title: 'Laporan Inventori',
      key: 'fullPath',
      resource: 'laporan'
    }
  },
  {
    path: '/apps/laporan/keuangan',
    name: 'apps-laporan-keuangan',
    component: () => import('@/views/apps/laporan/tabs/Keuangan.vue'),
    meta: {
      title: 'Laporan Keuangan',
      key: 'fullPath',
      resource: 'laporan'
    }
  },
  {
    path: '/apps/laporan/penerimaan',
    name: 'apps-laporan-penerimaan',
    component: () => import('@/views/apps/laporan/tabs/PenerimaanLaporan.vue'),
    meta: {
      title: 'Laporan Penerimaan',
      key: 'fullPath',
      resource: 'laporan'
    }
  },
  {
    path: '/apps/rekap-mcu',
    name: 'apps-rekap-mcu',
    component: () => import('@/views/apps/mcu/Rekap.vue'),
    meta: {
      title: 'Rekap MCU',
      key: 'fullPath',
      resource: 'rm mcu'
    }
  },
  // {
  //     path: '/apps/bisnisku',
  //     name: 'apps-bisnisku',
  //     component: () =>
  //         import ('@/views/apps/bisnis/Bisnisku.vue')
  // },
  {
    path: '/apps/pengaturan',
    name: 'apps-pengaturan',
    component: () => import('@/views/apps/setting/BasicSetting.vue'),
    meta: {
      title: 'Pengaturan',
      key: 'fullPath',
      // TODO: Permission Pengaturan
      // NOTE: tidak ada di navigation
      resource: 'pengaturan'
    }
  },
  {
    path: '/apps/hak-akses',
    name: 'apps-hak-akses',
    component: () => import('@/components/pengaturan/RolePermissionsManagement.vue'),
    meta: {
      title: 'Hak Akses',
      key: 'fullPath',
      resource: 'pengaturan'
    }
  },
  {
    path: '/apps/pengaturan/surat-template',
    name: 'apps-pengaturan-surat-template',
    component: () => import('@/views/apps/pengaturan/surat-template/SuratTemplateList.vue'),
    meta: {
      title: 'Template Surat & MCU',
      key: 'fullPath',
      resource: 'pengaturan-surat-template',
      action: 'view',
    },
  },
  {
    path: '/apps/changelog',
    name: 'apps-changelog',
    component: () => import('@/views/apps/changelog/Index.vue'),
    meta: {
      title: 'Changelog',
      key: 'fullPath',
      resource: 'Auth',
      alwaysAccessible: true
    }
  },
  // ========== Start Master Data ============
  {
    path: '/apps/icd',
    name: 'apps-icd',
    component: () => import('@/views/apps/master/Icd.vue'),
    meta: {
      title: 'ICD',
      key: 'fullPath'
      // TODO: Permission ICD
    }
  },
  {
    path: '/apps/karyawan',
    name: 'apps-karyawan',
    component: () => import('@/views/apps/master/Karyawan.vue'),
    meta: {
      title: 'Karyawan',
      key: 'fullPath',
      resource: 'karyawan'
    }
  },
  {
    path: '/apps/referensi',
    name: 'apps-referensi',
    component: () => import('@/views/apps/master/Referensi.vue'),
    meta: {
      title: 'Referensi',
      key: 'fullPath',
      resource: 'merk'
    }
  },
  {
    path: '/apps/merk',
    name: 'apps-merk',
    component: () => import('@/views/apps/master/Merk.vue'),
    meta: {
      title: 'Merk',
      key: 'fullPath',
      resource: 'merk'
    }
  },
  {
    path: '/apps/produsen',
    name: 'apps-produsen',
    component: () => import('@/views/apps/master/Produsen.vue'),
    meta: {
      title: 'Penyedia (PBF)',
      key: 'fullPath',
      resource: 'produsen'
    }
  },
  {
    path: '/apps/ruangan-v2',
    name: 'apps-ruangan-v2',
    component: () => import('@/views/apps/master/RuanganNew.vue'),
    meta: {
      title: 'Ruangan',
      key: 'fullPath',
      resource: 'ruangan'
    }
  },
  // {
  //     path: '/apps/ruangan-temp',
  //     name: 'apps-ruangan-temp',
  //     component: () =>
  //         import ('@/views/apps/master/RuanganTemp.vue')
  // },
  // {
  //   path: '/apps/ruangan/:id',
  //   name: 'apps-ruangan-detail',
  //   component: () => import('@/components/master/ruangan/Detail.vue'),
  //   meta: {
  //     title(route) {
  //       return `Ruangan ${route.params.id}`
  //     },
  //     key: 'fullPath',
  //     resource: 'ruangan'
  //   }
  // },
  {
    path: '/apps/paket-kunjungan',
    name: 'apps-paket-kunjungan',
    component: () => import('@/views/apps/master/PaketKunjungan.vue'),
    meta: {
      title: 'Paket Kunjungan',
      key: 'fullPath',
      resource: 'paket kunjungan'
    }
  },
  {
    path: '/apps/mcu-template',
    name: 'apps-mcu-template',
    component: () => import('@/views/apps/master/mcu-template/McuTemplateList.vue'),
    meta: {
      title: 'Template MCU',
      key: 'fullPath',
      resource: 'mcu template'
    }
  },
  {
    path: '/apps/tindakan',
    name: 'apps-tindakan',
    component: () => import('@/views/apps/master/Tindakan.vue'),
    meta: {
      title: 'Tindakan',
      key: 'fullPath',
      resource: 'tindakan'
    }
  },
  {
    path: '/apps/tarif',
    name: 'apps-tarif',
    component: () => import('@/views/apps/master/Tarif.vue'),
    meta: {
      title: 'Tarif',
      key: 'fullPath',
      resource: 'tarif'
    }
  },
  {
    path: '/apps/produk',
    name: 'apps-produk',
    component: () => import('@/views/apps/master/ProdukObat.vue'),
    meta: {
      title: 'Produk',
      key: 'fullPath',
      resource: 'produk'
    }
  },
  {
    path: '/apps/loket',
    name: 'apps-loket',
    component: () => import('@/views/apps/master/Loket.vue'),
    meta: {
      title: 'Loket',
      key: 'fullPath',
      resource: 'loket'
    }
  },
  {
    path: '/apps/monitor',
    name: 'apps-monitor',
    component: () => import('@/views/apps/master/monitor/MonitorSetting.vue'),
    meta: {
      title: 'Monitor Antrean',
      pageTitle: 'Pengaturan Monitor Antrean',
      breadcrumb: [
        { text: 'Master Data' },
        { text: 'Monitor Antrean', active: true },
      ],
      key: 'fullPath',
      resource: 'monitor',
      action: 'view',
    },
  },
  {
    path: '/display/:token',
    name: 'public-queue-display',
    component: () => import('@/views/public/display/QueueDisplay.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
      alwaysAccessible: true,
      title: 'Layar Antrean',
    },
  },
  {
    path: '/apps/setting/main',
    name: 'apps-setting-main',
    component: () => import('@/views/apps/setting/BasicSetting.vue'),
    meta: {
      title: 'Setting',
      key: 'fullPath',
      resource: 'kunjungan'
    }
  },
  // ========== End Master Data ============

  {
    path: '/print/etiket',
    name: 'print-etiket',
    component: () => import('@/views/apps/pasien/cetakan/PrintEtiket.vue'),
    meta: {
      title: 'Etiket',
      key: 'fullPath'
      // TODO: Permission Etiket
      // NOTE: tidak ada di navigation
    }
  },

  // ========== Start Integrasi ============

  {
    path: '/integrasi/satu-sehat',
    name: 'integrasi-satu-sehat',
    component: () => import('@/views/apps/integrasi/SatuSehat.vue'),
    meta: {
      title: 'Satu Sehat',
      key: 'fullPath',
      resource: 'satusehat',
      feature: 'satu_sehat'
    }
  },
  {
    path: '/integrasi/satu-sehat/:type',
    name: 'integrasi-list-satu-sehat',
    component: () => import('@/views/apps/integrasi/SatuSehatDetail.vue'),
    props: true,
    meta: {
      title(route) {
        return `(SS) ${route.params.type}`
      },
      key: 'fullPath',
      resource: 'satusehat',
      feature: 'satu_sehat'
    }
  },
  {
    path: '/integrasi/kfa-mapping',
    name: 'integrasi-kfa-mapping',
    component: () => import('@/views/apps/integrasi/KfaMapping.vue'),
    meta: {
      title: 'KFA Drug Mapping',
      key: 'fullPath',
      resource: 'satusehat',
      feature: 'satu_sehat'
    }
  },
  {
    path: '/integrasi/bpjs',
    name: 'integrasi-bpjs',
    component: () => import('@/views/apps/integrasi/BpjsFktp.vue'),
    meta: {
      title: 'BPJS FKTP',
      key: 'fullPath',
      resource: 'satusehat',
      feature: 'bpjs'
    }
  },

  // ========== End Integrasi ============

  // ========== Start Monitoring ============

  {
    path: '/apps/monitoring/jadwal-kontrol',
    name: 'apps-monitoring-jadwal-kontrol',
    component: () => import('@/views/apps/monitoring/jadwal-kontrol/Index.vue'),
    meta: {
      title: 'Monitoring Jadwal Kontrol',
      key: 'fullPath',
      resource: 'kunjungan',
      feature: 'rawat_jalan'
    }
  },

  {
    path: '/apps/monitoring/ulang-tahun',
    name: 'apps-monitoring-ulang-tahun',
    component: () => import('@/views/apps/monitoring/ulang-tahun/index.vue'),
    meta: {
      title: 'Monitoring Ulang Tahun',
      key: 'fullPath',
      resource: 'tabel pasien'
    }
  },

  {
    path: '/apps/monitoring/persediaan',
    name: 'apps-monitoring-persediaan',
    component: () => import('@/views/apps/monitoring/persediaan/Index.vue'),
    meta: {
      title: 'Monitoring Persediaan',
      key: 'fullPath',
      resource: 'stock',
      feature: 'inventory'
    }
  },

  {
    path: '/apps/monitoring/pcare-bpjs',
    name: 'apps-monitoring-pcare-bpjs',
    component: () => import('@/views/apps/monitoring/PCareBpjs.vue'),
    meta: {
      title: 'Monitoring BPJS',
      key: 'fullPath',
      resource: 'satusehat',
      feature: 'bpjs'
    }
  },

  // ========== End Monitoring ============

  {
    path: '/documents/general-consent',
    name: 'documents-general-consent',
    component: () => import('@/views/apps/document/GeneralConsent.vue'),
    meta: {
      title: 'General Consent',
      layout: 'full',
      alwaysAccessible: true
    }
  },
  // Public Invoice Page (shareable payment link)
  {
    path: '/i/:token',
    name: 'public-invoice',
    component: () => import('@/views/public/PublicInvoicePage.vue'),
    meta: {
      title: 'Invoice Pembayaran',
      layout: 'full',
      alwaysAccessible: true
    }
  },
  // Public Contract Page (e-signature link)
  {
    path: '/c/:token',
    name: 'public-contract',
    component: () => import('@/views/public/PublicContractPage.vue'),
    meta: {
      title: 'Kontrak Elektronik',
      layout: 'full',
      alwaysAccessible: true
    }
  },
  // Public MCU Form (shareable patient link)
  {
    path: '/mcu/:token',
    name: 'public-mcu-form',
    component: () => import('@/views/public/PublicMcuForm.vue'),
    meta: {
      title: 'Form Medical Check Up',
      layout: 'full',
      alwaysAccessible: true
    }
  },
  // Public General Consent (shareable patient signing link)
  {
    path: '/general-consent/:token',
    name: 'public-general-consent',
    component: () => import('@/views/public/PublicGeneralConsent.vue'),
    meta: {
      title: 'Persetujuan Umum',
      layout: 'full',
      alwaysAccessible: true
    }
  },
  // Public Surat Pernyataan APS (shareable patient/family signing link)
  {
    path: '/surat-aps/:token',
    name: 'public-surat-aps',
    component: () => import('@/views/public/PublicSuratAps.vue'),
    meta: {
      title: 'Surat Pernyataan Pulang Atas Permintaan Sendiri',
      layout: 'full',
      alwaysAccessible: true
    }
  },
  // Public patient info sheet (page 4 of the General Consent form) — opened in a
  // new tab from the consent form so the in-progress signature is never lost.
  {
    path: '/informasi-pasien/:section?',
    name: 'public-patient-info',
    component: () => import('@/views/public/PublicPatientInfo.vue'),
    meta: {
      title: 'Informasi Pasien',
      layout: 'full',
      alwaysAccessible: true
    }
  },
  // Public Klaim Approval (shareable approver link)
  {
    path: '/public/klaim/:token',
    name: 'public-klaim-approval',
    component: () => import('@/views/public/PublicKlaimApproval.vue'),
    meta: {
      title: 'Persetujuan Klaim',
      layout: 'full',
      alwaysAccessible: true
    }
  },

  // ========== Start Pengklaiman ============

  {
    path: '/apps/pengklaiman',
    name: 'apps-pengklaiman',
    component: () => import('@/views/apps/pengklaiman/Index.vue'),
    meta: {
      title: 'Pengklaiman',
      action: 'view',
      resource: 'pengklaiman',
      feature: 'pengklaiman',
    },
  },
  {
    path: '/apps/pengklaiman/:penjaminId',
    name: 'apps-pengklaiman-penjamin',
    component: () => import('@/views/apps/pengklaiman/KlaimPerPenjamin.vue'),
    meta: {
      title: 'Klaim Asuransi',
      action: 'view',
      resource: 'pengklaiman',
    },
  },

  // ========== End Pengklaiman ============
]
